import Repository from "./Repository";
const GET_ALL_ORDERS = "order/all";
const GET_SPECIAL_ORDERS = "/order/special-order";
const GET_ORDER_SEARCH_BY_ID = "order/search";
const GET_SPECIAL_ORDER_SEARCH_BY_ID = "/order/special-order/search";

export default {
  getOrders(status, page) {
    return Repository.get(
      `${GET_ALL_ORDERS}?page=${page}&limit=10${
        status ? `&status=${status}` : ""
      }`
    );
  },
  getSpecialOrders(status, page) {
    return Repository.get(
      `${GET_SPECIAL_ORDERS}?page=${page}&limit=10${
        status ? `&status=${status}` : ""
      }`
    );
  },
  orderSearchById(id, page) {
    return Repository.get(`${GET_ORDER_SEARCH_BY_ID}/${id}?page=${page}`);
  },
  specialOrderSearchById(id, page) {
    return Repository.get(
      `${GET_SPECIAL_ORDER_SEARCH_BY_ID}/${id}?page=${page}`
    );
  },
  releasePayment(id) {
    return Repository.post(`/order/release-payment`, { orderId: id });
  },
};
